var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"item-list",class:{ side: _vm.sidebar },attrs:{"id":"item-list"}},_vm._l((_vm.item.material),function(material){return _c('li',{key:material.name,class:{ active: material.active },on:{"click":function($event){return _vm.$emit(
        'onClickCombination',
        _vm.item.id,
        material.material_id,
        _vm.item.isMultiple,
        _vm.item.isOverlay
      )}}},[(!_vm.item.isMultiple || (_vm.item.isMultiple && material.isDisabled))?[_c('img',{attrs:{"src":_vm._f("getThumbnail")(material.name,_vm.item.name, _vm.configuratorName),"alt":"Material Thumbnail"}}),_c('span',[_vm._v(_vm._s(_vm._f("removeUnderscores")(material.name)))]),_c('br')]:_vm._e()],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }